const keywords = [
  'alignas',
  'alignof',
  'and',
  'and_eq',
  'asm',
  'auto',
  'bitand',
  'bitor',
  'bool',
  'break',
  'case',
  'catch',
  'char',
  'char8_t',
  'char16_t',
  'char32_t',
  'class',
  'compl',
  'concept',
  'const',
  'consteval',
  'constexpr',
  'constinit',
  'const_cast',
  'continue',
  'co_await',
  'co_return',
  'co_yield',
  'decltype',
  'default',
  'delete',
  'do',
  'double',
  'dynamic_cast',
  'else',
  'enum',
  'explicit',
  'export',
  'extern',
  'false',
  'float',
  'for',
  'friend',
  'goto',
  'if',
  'include',
  'inline',
  'int',
  'long',
  'mutable',
  'namespace',
  'new',
  'noexcept',
  'not',
  'not_eq',
  'nullptr',
  'operator',
  'or',
  'or_eq',
  'private',
  'protected',
  'public',
  'register',
  'reinterpret_cast',
  'requires',
  'return',
  'short',
  'signed',
  'sizeof',
  'static',
  'static_assert',
  'static_cast',
  'struct',
  'switch',
  'template',
  'this',
  'thread_local',
  'throw',
  'true',
  'try',
  'typedef',
  'typeid',
  'typename',
  'union',
  'unsigned',
  'using',
  'virtual',
  'void',
  'volatile',
  'wchar_t',
  'while',
  'xor',
  'xor_eq'
]

const classes = [
  'algorithm',
  'bits/stdc++.h',
  'deque',
  'iterator',
  'iostream',
  'list',
  'cmath',
  'map',
  'memory',
  'queue',
  'set',
  'stack',
  'utility',
  'vector'
]

const objects = ['cerr', 'cin', 'clog', 'cout', 'endl', 'wcin', 'wcerr', 'wclog', 'wout', 'std']

const functions = [
  'main',
  'abs',
  'acos',
  'acosh',
  'adjacent_difference',
  'adjacent_find',
  'all_of',
  'any_of',
  'as_const',
  'asin',
  'asinh',
  'assign',
  'atan',
  'atan2',
  'atanh',
  'at',
  'back',
  'begin',
  'binary_search',
  'cbrt',
  'ceil',
  'cbegin',
  'cend',
  'clear',
  'copysign',
  'cos',
  'cosh',
  'count',
  'copy',
  'copy_backward',
  'copy_if',
  'copy_n',
  'crbegin',
  'crend',
  'count_if',
  'data',
  'declval',
  'emplace',
  'emplace_back',
  'emplace_front',
  'emplace_hint',
  'empty',
  'end',
  'equal',
  'equal_range',
  'erase',
  'erf',
  'erfc',
  'exp',
  'exp2',
  'expm1',
  'exchange',
  'fabs',
  'fdim',
  'fill',
  'fill_n',
  'find',
  'find_end',
  'find_first_of',
  'find_if',
  'find_if_not',
  'floor',
  'for_each',
  'forward',
  'fma',
  'fmax',
  'fmin',
  'fmod',
  'fpclassify',
  'frexp',
  'front',
  'generate',
  'generate_n',
  'hypot',
  'ilogb',
  'includes',
  'inplace_merge',
  'insert',
  'is_heap',
  'is_heap_until',
  'isfinite',
  'isgreater',
  'isgreaterequal',
  'is_partitioned',
  'is_permutation',
  'is_sorted',
  'is_sorted_until',
  'isless',
  'islessequal',
  'islessgreater',
  'isnormal',
  'isunordered',
  'iter_swap',
  'key_comp',
  'ldexp',
  'lexicographical_compare',
  'llrint',
  'llround',
  'log',
  'log10',
  'log1p',
  'log2',
  'logb',
  'lower_bound',
  'lrint',
  'lround',
  'make_heap',
  'make_pair',
  'max',
  'max_element',
  'max_size',
  'merge',
  'min',
  'min_element',
  'minmax',
  'minmax_element',
  'mismatch',
  'modf',
  'move',
  'move_backward',
  'move_if_noexcept',
  'nan',
  'nearbyint',
  'next_permutation',
  'nextafter',
  'nexttoward',
  'none_of',
  'nth_element',
  'operator[]',
  'pair',
  'partial_sort',
  'partial_sort_copy',
  'partition',
  'partition_point',
  'pop',
  'pop_back',
  'pop_front',
  'pop_heap',
  'pow',
  'prev_permutation',
  'push',
  'push_back',
  'push_front',
  'push_heap',
  'random_shuffle',
  'remainder',
  'remove',
  'remove_copy',
  'remove_copy_if',
  'remove_if',
  'remquo',
  'replace',
  'replace_copy',
  'replace_copy_if',
  'replace_if',
  'reserve',
  'resize',
  'reverse',
  'reverse_copy',
  'rint',
  'rotate',
  'rotate_copy',
  'round',
  'rbegin',
  'rend',
  'scalbln',
  'scalbn',
  'search',
  'search_n',
  'set_difference',
  'set_intersection',
  'set_symmetric_difference',
  'set_union',
  'shrink_to_fit',
  'shuffle',
  'signbit',
  'sin',
  'sinh',
  'size',
  'sort',
  'sort_heap',
  'splice',
  'sqrt',
  'stable_partition',
  'stable_sort',
  'swap',
  'swap_ranges',
  'tan',
  'tanh',
  'tgamma',
  'transform',
  'trunc',
  'unique',
  'unique_copy',
  'upper_bound',
  'value_comp'
]
export default {
  keywords,
  classes,
  objects,
  functions
}
